import { useSelector } from 'react-redux';

import { getSubscriptionPlan } from '@app/features/subscription/state';
import useMemberPermissions from '@app/hooks/useMemberPermission';
import useUsageCount from '@app/hooks/useUsageCount';
import { useWorkspace } from '@app/hooks/workspace';

export const SigningRequestAuthorizationErrorMessage = {
  noPlan: '워크스페이스 관리자에게 요금제 구매를 요청해 주세요.',
  noPermission: '서명 요청 권한이 없습니다.',
  noRemainingCount: '워크스페이스 관리자에게 충전을 요청해 주세요.',
  hasPublicWorkspace: '개인 워크스페이스에서는 서명 요청할 수 없습니다.',
};

function useAuthorizeContractSetupStartButtonErrorMessage() {
  const { isPermitted: isSigningRequestPermitted } = useMemberPermissions('CREATE_DOCUMENT');
  const { signingRequestCount } = useUsageCount();
  const plan = useSelector(getSubscriptionPlan);
  const ws = useWorkspace();

  if (!ws.active) {
    return SigningRequestAuthorizationErrorMessage.hasPublicWorkspace;
  }

  if (!plan) {
    // 조직 멤버 && 조직 기능 권한이 없으면 "조직 요금제"가 STOPPED 상태이라고 볼 수 있다.
    return SigningRequestAuthorizationErrorMessage.noPlan;
  }
  if (!isSigningRequestPermitted) {
    return SigningRequestAuthorizationErrorMessage.noPermission;
  }
  if (signingRequestCount.limit - signingRequestCount.usage <= 0) {
    return SigningRequestAuthorizationErrorMessage.noRemainingCount;
  }

  return undefined;
}

export default useAuthorizeContractSetupStartButtonErrorMessage;
